import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { BasicModal } from "components/common/modals/BasicModal";
import { default as Loadable } from "components/_Shared/commonLoadable";

// Utils
import { resetPassword } from "utils/api/user/requests";
import { checkEmailInput } from "utils/validations";

// Style
import {
  Container,
  Text,
  Form,
  FormContainer,
  StyledInput,
  StyledButton,
  SuccessText,
  ErrorText
} from "./ForgotPasswordModal.style";

export const ForgotPasswordModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const validate = () => {
    const emailError = checkEmailInput(email);
    setEmailError(emailError);
    return emailError.length > 0;
  };

  const handleSubmit = async event => {
    event.preventDefault();
    const hasErrors = validate();

    if (!hasErrors) {
      setIsLoading(true);
      await resetPassword({ email })
        .then(res => {
          setShowSuccessMessage(true);
        })
        .catch(error => {
          setEmailError(error);
        });
      setIsLoading(false);
    }
  };

  return (
    <BasicModal
      open={open}
      onClose={() => {
        onClose(false);
      }}
      withCloseButton
    >
      <Container>
        <Text>{t("ForgotPasswordModal.Text")}</Text>
        {showSuccessMessage ? (
          <SuccessText>{t("ForgotPasswordModal.Success")}</SuccessText>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Loadable active={isLoading} spinnerSize="10px">
              <FormContainer>
                <StyledInput
                  name="email"
                  type="text"
                  placeholder={t("ForgotPasswordModal.Placeholder")}
                  value={email}
                  onChange={val => {
                    setEmail(val.target.value);
                    setEmailError("");
                  }}
                />
                <StyledButton title={t("ForgotPasswordModal.Button.Title")}>
                  {t("ForgotPasswordModal.Button.Label")}
                </StyledButton>
              </FormContainer>
            </Loadable>
          </Form>
        )}
        {emailError ? <ErrorText>{emailError}</ErrorText> : null}
      </Container>
    </BasicModal>
  );
};

ForgotPasswordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
